// import React from "react";
// import { Modal, Button } from "react-bootstrap";

// const DisburseBranchManagerModal = ({
//   show,
//   handleClose,
//   handleConfirm,
//   message,
//   proposedLoanAmount,
//   sanctionedLoanAmount,
//   processingCharge,
//   isProcessingChargePaid,
//   setIsProcessingChargePaid,
//   gst,
//   isGstPaid,
//   setIsGstPaid,
//   securityDeposit,
//   isSecurityDepositPaid,
//   setIsSecurityDepositPaid,
//   isLoanInsured,
//   setIsLoanInsured,
//   insuranceAmount,
//   // setInsuranceAmount,
//   isInsuranceAmountPaid,
//   setIsInsuranceAmountPaid,
//   amountToRelease,
//   setAmountToRelease,
//   emiDateByBranchManager,
//   loanType,
//   ornamentModelNoByBm,
//   setOrnamentModelNoByBm,
//   ornamentNameByBm,
//   setOrnamentNameByBm,
//   ornamentWeightByBm,
//   setOrnamentWeightByBm,
//   wastageByBm,
//   setWastageByBm,
//   gstByBm,
//   setGstByBm,
//   goldRateByBm,
//   setGoldRateByBm,
//   ornamentWeightValueByBm,
//   wastageValueByBm,
//   totalByBm,
//   gstValueByBm,
//   goldloantotal,
//   cashtloanotal,
//   eligibleLoanAmountByBm,
//   totalLoanAmountByBm,
// }) => {
//   return (
//     <Modal show={show} onHide={handleClose}>
//       <Modal.Header closeButton>
//         <Modal.Title>Confirmation</Modal.Title>
//       </Modal.Header>
//       <Modal.Body>
//         {message}
//         {loanType === "Business Loan" && (
//           <>
//             <p>Proposed Loan Amount : Rs.{proposedLoanAmount}</p>
//             <p>Sanctioned Loan Amount : Rs.{sanctionedLoanAmount}</p>
//             <p>Processing Charge : Rs.{processingCharge}</p>
//             <p>GST Amount : Rs.{gst}</p>
//             <p>Security Deposit : Rs.{securityDeposit}</p>
//             <p>Loan Insured? : {isLoanInsured ? "Yes" : "No"}</p>
//             {isLoanInsured && (
//               <>
//                 <p>Insurance Amount : Rs.{insuranceAmount}</p>
//               </>
//             )}
//             <p>Loan Amount to Release : Rs.{amountToRelease}</p>
//             <p>EMI Date by Branch Manager: {emiDateByBranchManager}</p>
//           </>
//         )}
//         {loanType === "GP Loan" && (
//           <>
//             <p>Proposed Loan Amount : Rs.{proposedLoanAmount}</p>
//             <p>Gold Rate : Rs.{goldRateByBm}</p>
//             <p>Ornament Model No : {ornamentModelNoByBm}</p>
//             <p>Ornament Name : {ornamentNameByBm}</p>
//             <p>Ornament Weight : {ornamentWeightByBm}</p>
//             <p>Ornament Weight Value :Rs.{ornamentWeightValueByBm}</p>
//             <p>Wastage : {wastageByBm}</p>
//             <p>Wastage Value : Rs.{wastageValueByBm}</p>
//             <p>GST : {gstByBm}</p>
//             <p>GST Value : {gstValueByBm}</p>
//             <p>CashLoaan : {cashtloanotal}</p>
//             <p>Gold Loan : {goldloantotal}</p>
//             <p>Eligible Loan Amount : Rs.{eligibleLoanAmountByBm}</p>
//             <p>Processing Charge : Rs.{processingCharge}</p>
//             <p>GST Amount : Rs.{gst}</p>
//             <p>Loan Insured? : {isLoanInsured ? "Yes" : "No"}</p>
//             {isLoanInsured && (
//               <>
//                 <p>Insurance Amount : Rs.{insuranceAmount}</p>
//               </>
//             )}
//             {/* <p> Security Deposit : {memberdetails.securityDeposit}</p> */}
//             <p>EMI Date by Branch Manager: {emiDateByBranchManager}</p>
//           </>
//         )}
//       </Modal.Body>
//       <Modal.Footer>
//         <Button variant="secondary" onClick={handleClose}>
//           Cancel
//         </Button>
//         <Button variant="primary" onClick={handleConfirm}>
//           Disburse
//         </Button>
//       </Modal.Footer>
//     </Modal>
//   );
// };

// export default DisburseBranchManagerModal;

import React from "react";
import { Modal, Button } from "react-bootstrap";
import { GPL_HIGH_VALUE_THRESHOLD } from "../../../utils/utils";

const DisburseBranchManagerModal = ({
  show,
  handleClose,
  handleConfirm,
  message,
  proposedLoanAmount,
  sanctionedLoanAmount,
  processingCharge,
  isProcessingChargePaid,
  setIsProcessingChargePaid,
  gst,
  isGstPaid,
  setIsGstPaid,
  securityDeposit,
  isSecurityDepositPaid,
  setIsSecurityDepositPaid,
  isLoanInsured,
  setIsLoanInsured,
  insuranceAmount,
  // setInsuranceAmount,
  isInsuranceAmountPaid,
  setIsInsuranceAmountPaid,
  amountToRelease,
  setAmountToRelease,
  emiDateByBranchManager,
  loanType,
  ornamentModelNoByBm,
  setOrnamentModelNoByBm,
  ornamentNameByBm,
  setOrnamentNameByBm,
  ornamentWeightByBm,
  setOrnamentWeightByBm,
  wastageByBm,
  setWastageByBm,
  gstByBm,
  setGstByBm,
  goldRateByBm,
  setGoldRateByBm,
  ornamentWeightValueByBm,
  wastageValueByBm,
  totalByBm,
  gstValueByBm,
  goldloantotal,
  cashtloanotal,
  eligibleLoanAmountByBm,
  totalLoanAmountByBm,
  fundingAgencyData,
}) => {
  const formatEmiDate = (emiDay) => {
    if (!emiDay) return "-";
    
    // If it's already a full date (e.g. YYYY-MM-DD or containing '-'), format it to DD-MM-YYYY
    if (typeof emiDay === "string" && emiDay.includes("-")) {
      const parts = emiDay.split("-");
      if (parts.length === 3) {
        if (parts[0].length === 4) {
          return `${parts[2].padStart(2, '0')}-${parts[1].padStart(2, '0')}-${parts[0]}`;
        }
        return emiDay;
      }
    }

    const day = parseInt(emiDay);
    if (isNaN(day) || day < 1 || day > 31) return emiDay;

    const today = new Date();
    let startMonth = today.getMonth() + 1; // Month after disbursement (next month)
    let startYear = today.getFullYear();

    if (startMonth > 11) {
      startMonth = 0;
      startYear += 1;
    }

    // Get last day of next month to handle case like day=31 in February etc.
    const lastDay = new Date(startYear, startMonth + 1, 0).getDate();
    const targetDay = Math.min(day, lastDay);

    const formattedDay = String(targetDay).padStart(2, "0");
    const formattedMonth = String(startMonth + 1).padStart(2, "0"); // 1-indexed

    return `${formattedDay}-${formattedMonth}-${startYear}`;
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Confirmation</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {message}
        {loanType === "Business Loan" && (
          <>
            <p>Proposed Loan Amount : Rs.{proposedLoanAmount}</p>
            <p>Sanctioned Loan Amount : Rs.{sanctionedLoanAmount}</p>
            <p>Processing Charge : Rs.{processingCharge}</p>
            <p>GST Amount : Rs.{gst}</p>
            {(!fundingAgencyData || fundingAgencyData.blSecurityDepositEnabled !== false) && (
              <p>Security Deposit : Rs.{securityDeposit}</p>
            )}
            {(!fundingAgencyData || fundingAgencyData.blInsuranceEnabled !== false) && (
              <>
                <p>Loan Insured? : {isLoanInsured ? "Yes" : "No"}</p>
                {isLoanInsured && (
                  <>
                    <p>Insurance Amount : Rs.{insuranceAmount}</p>
                  </>
                )}
              </>
            )}
            <p>Loan Amount to Release : Rs.{amountToRelease}</p>
            <p>EMI Date by Branch Manager: {formatEmiDate(emiDateByBranchManager)}</p>
          </>
        )}
        {loanType === "GP Loan" && (
          <>
            <p>Proposed Loan Amount : Rs.{proposedLoanAmount}</p>
            <p>Gold Rate : Rs.{goldRateByBm}</p>
            <p>Ornament Model No : {ornamentModelNoByBm}</p>
            <p>Ornament Name : {ornamentNameByBm}</p>
            <p>Ornament Weight : {ornamentWeightByBm}</p>
            <p>Ornament Weight Value :Rs.{ornamentWeightValueByBm}</p>
            <p>Wastage : {wastageByBm}</p>
            <p>Wastage Value : Rs.{wastageValueByBm}</p>
            <p>GST : {gstByBm}</p>
            <p>GST Value : {gstValueByBm}</p>
            <p>Cash Loan : {cashtloanotal}</p>
            <p>Gold Loan : {goldloantotal}</p>
            {(!fundingAgencyData || fundingAgencyData.gplSecurityDepositEnabled !== false) && (
              <p>Security Deposite : {securityDeposit} </p>
            )}
            <p>Eligible Loan Amount : Rs.{eligibleLoanAmountByBm}</p>
            <p>Processing Charge : Rs.{processingCharge}</p>
            <p>GST Amount : Rs.{gst}</p>
            {(!fundingAgencyData || fundingAgencyData.gplInsuranceEnabled !== false || (totalLoanAmountByBm >= GPL_HIGH_VALUE_THRESHOLD && fundingAgencyData.gplInsuranceAbove199999Enabled !== false)) && (
              <>
                <p>Loan Insured? : {isLoanInsured ? "Yes" : "No"}</p>
                {isLoanInsured && (
                  <>
                    <p>Insurance Amount : Rs.{insuranceAmount}</p>
                  </>
                )}
              </>
            )}
            {/* <p> Security Deposit : {memberdetails.securityDeposit}</p> */}
            <p>EMI Date by Branch Manager: {formatEmiDate(emiDateByBranchManager)}</p>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleConfirm}>
          Disburse
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DisburseBranchManagerModal;